import { PENDING, FAILURE, SUCCESS } from "../constants";
import { FETCH_PLACEMENT_INFO } from "./constants";
import { fetchPlacementInfo } from "../../services/sql/placementInfo";

let nonUSAdvertisers = [
  6339928, 9351410, 3919610, 3919616, 3919510, 3919582, 3919605, 13206563,
  6648902, 3919529, 5597615, 3919498, 4249606
];

export const getPlacementInfo = (dcmCampaignId) => {
  return (dispatch) => {
    dispatch(requestPlacementInfo(dcmCampaignId));
    fetchPlacementInfo(dcmCampaignId)
      .then((data) => {
        // // TEMPORARY FIX FOR SERVING TYPE 2026 NON US ADVERTISERS
        // // check each placement and if advertiser is a US advertiser
        // let newData = data.map((placement) => {
        //   let placementYear = new Date(placement.Start_Date).getFullYear();
        //   if (
        //     nonUSAdvertisers.includes(placement.Advertiser_Id) &&
        //     placementYear >= 2026
        //   ) {
        //     // grab the 9th guillement position from the placement name (servingType)
        //     let correctedServingType = placement.Placement.split("»")[8];
        //     switch (correctedServingType) {
        //       case "SS":
        //         placement.Serving_Type = "Site";
        //         break;
        //       case "TP":
        //         placement.Serving_Type = "3rd party";
        //         break;
        //       default:
        //         break;
        //     }
        //     return placement;
        //   } else {
        //     return placement;
        //   }
        // });
        // // END TEMPORARY FIX

        dispatch(receivePlacementInfo(data));
      })
      .catch((err) => {
        dispatch(failurePlacementInfo(err));
      });
  };
};

export const requestPlacementInfo = (dcmCampaignId) => {
  return {
    type: FETCH_PLACEMENT_INFO,
    status: PENDING,
    dcmCampaignId
  };
};

export const failurePlacementInfo = (err) => {
  return {
    type: FETCH_PLACEMENT_INFO,
    status: FAILURE,
    error: err
  };
};

export const receivePlacementInfo = (data) => {
  return {
    type: FETCH_PLACEMENT_INFO,
    status: SUCCESS,
    placementInfo: data
  };
};
